{
  "name": "denticare",
  "version": "20.3.0",
  "scripts": {
    "serve": "ng serve --hmr",
    "serveSSL": "ng serve --ssl",
    "denticare:serveSSL": "ng serve denticare -c dev --ssl",
    "myhealthbeauty:serveSSL": "ng serve MyHealthBeauty -c dev --ssl",
    "myhealthcare:serveSSL": "ng serve MyHealthCare -c dev --ssl",
    "build": "ng build",
    "build:stats": "ng build denticare --stats-json",
    "webpack:open": "npx webpack-bundle-analyzer dist/stats.json",
    "denticare:serve:local": "ng serve denticare -c local --port 4200  --host 0.0.0.0 --disable-host-check",
    "denticare:serve:dev": "ng serve denticare -c dev",
    "denticare:serve:uat": "ng serve denticare -c uat",
    "denticare:serve:stage": "ng serve denticare -c stage",
    "denticare:serve:prod": "ng serve denticare -c production",
    "denticare:build:local": "ng build denticare",
    "denticare:build:dev": "ng build denticare -c dev --output-hashing=all --index=src/index/DentiCare/index.html",
    "denticare:build:uat": "ng build denticare -c uat --output-hashing=all --index=src/index/DentiCare/index.html",
    "denticare:build:stage": "ng build denticare -c stage --output-hashing=all --index=src/index/DentiCare/index.html",
    "denticare:build:sandbox": "ng build denticare -c sandbox --output-hashing=all --index=src/index/DentiCare/index.html",
    "denticare:build:migration": "ng build denticare -c migration --output-hashing=all --index=src/index/DentiCare/index.html",
    "denticare:build:prod": "ng build denticare -c production --output-hashing=all --index=src/index/DentiCare/index.html",
    "denticare:build:vendor": "ng build denticare -c vendor --output-hashing=all --index=src/index/DentiCare/index.html",
    "myhealthbeauty:serve:local": "ng serve MyHealthBeauty -c local --port 4201",
    "myhealthbeauty:serve:dev": "ng serve MyHealthBeauty -c dev --port 4201",
    "myhealthbeauty:serve:uat": "ng serve MyHealthBeauty -c uat --port 4201",
    "myhealthbeauty:serve:stage": "ng serve MyHealthBeauty -c stage --port 4201",
    "myhealthbeauty:serve:prod": "ng serve MyHealthBeauty -c production --port 4201",
    "myhealthcare:serve:local": "ng serve MyHealthCare -c local --port 4202",
    "myhealthcare:serve:dev": "ng serve MyHealthCare -c dev --port 4202",
    "myhealthcare:serve:uat": "ng serve MyHealthCare -c uat --port 4202",
    "myhealthcare:serve:stage": "ng serve MyHealthCare -c stage --port 4202",
    "myhealthcare:serve:prod": "ng serve MyHealthCare -c production --port 4202",
    "myhealthbeauty:build:local": "ng build MyHealthBeauty",
    "myhealthbeauty:build:dev": "ng build MyHealthBeauty -c dev --output-hashing=all --index=src/index/MyHealthBeauty/index.html",
    "myhealthbeauty:build:uat": "ng build MyHealthBeauty -c uat --output-hashing=all --index=src/index/MyHealthBeauty/index.html",
    "myhealthbeauty:build:stage": "ng build MyHealthBeauty -c stage --output-hashing=all --index=src/index/MyHealthBeauty/index.html",
    "myhealthbeauty:build:sandbox": "ng build MyHealthBeauty -c sandbox --output-hashing=all --index=src/index/MyHealthBeauty/index.html",
    "myhealthbeauty:build:prod": "ng build MyHealthBeauty -c production --output-hashing=all --index=src/index/MyHealthBeauty/index.html",
    "myhealthcare:build:local": "ng build MyHealthCare",
    "myhealthcare:build:dev": "ng build MyHealthCare -c dev --output-hashing=all --index=src/index/MyHealthCare/index.html",
    "myhealthcare:build:uat": "ng build MyHealthCare -c uat --output-hashing=all --index=src/index/MyHealthCare/index.html",
    "myhealthcare:build:stage": "ng build MyHealthCare -c stage --output-hashing=all  --index=src/index/MyHealthCare/index.html",
    "myhealthcare:build:sandbox": "ng build MyHealthCare -c sandbox --output-hashing=all --index=src/index/MyHealthCare/index.html",
    "myhealthcare:build:prod": "ng build MyHealthCare -c production --output-hashing=all --index=src/index/MyHealthCare/index.html",
    "extract:i18n": "ng extract-i18n --format=json --output-path=src/locale",
    "build-and-push": "npm run build && node ci.js",
    "test": "ng test",
    "test:local": "ng test --watch=true --source-map=true --code-coverage=true",
    "test-with-coverage": "ng test --code-coverage",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@almothafar/angular-signature-pad": "^5.0.1",
    "@angular/animations": "^19.2.20",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.20",
    "@angular/compiler": "^19.2.20",
    "@angular/core": "^19.2.20",
    "@angular/forms": "^19.2.20",
    "@angular/localize": "^19.2.20",
    "@angular/material": "^19.2.19",
    "@angular/material-moment-adapter": "^19.2.19",
    "@angular/platform-browser": "^19.2.20",
    "@angular/platform-browser-dynamic": "^19.2.20",
    "@angular/router": "^19.2.20",
    "@ckeditor/ckeditor5-angular": "^9.1.0",
    "@iconscout/unicons": "^4.0.8",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@ng-select/ng-select": "^14.0.0",
    "@ngrx/store": "^19.0.0",
    "@ngrx/store-devtools": "^19.0.0",
    "@ngx-loading-bar/core": "^7.0.1",
    "@ngx-loading-bar/http-client": "^7.0.1",
    "@ngx-loading-bar/router": "^7.0.1",
    "angular-csv": "^1.0.0",
    "angular-csv-ext": "^1.0.5",
    "bootstrap": "^4.6.2",
    "browser-image-compression": "^2.0.2",
    "core-js": "^3.6.4",
    "crypto-js": "^4.1.1",
    "date-fns": "^2.21.1",
    "google-libphonenumber": "^3.2.26",
    "http-status-codes": "^2.1.4",
    "hybrid-crypto-js": "^0.2.4",
    "libphonenumber-js": "^1.10.44",
    "material-calendar": "^3.2.0",
    "moment": "^2.29.1",
    "ngx-device-detector": "^9.0.0",
    "ngx-file-drop": "16.0.0",
    "ngx-mask": "^19.0.0",
    "ngx-pagination": "^6.0.3",
    "ngx-skeleton-loader": "^8.1.0",
    "ngx-toastr": "^19.1.0",
    "rxjs": "^7.8.1",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.22",
    "@angular-eslint/builder": "^19.0.0",
    "@angular-eslint/eslint-plugin": "^19.0.0",
    "@angular-eslint/eslint-plugin-template": "^19.0.0",
    "@angular-eslint/schematics": "^19.0.0",
    "@angular-eslint/template-parser": "^19.0.0",
    "@angular/cli": "^19.2.22",
    "@angular/compiler-cli": "^19.2.20",
    "@types/crypto-js": "^4.2.2",
    "@types/dockerode": "^3.2.3",
    "@types/jasmine": "~3.8.0",
    "@types/node": "^12.11.1",
    "@typescript-eslint/eslint-plugin": "^8.0.0",
    "@typescript-eslint/parser": "^8.0.0",
    "ckeditor5": "^45.0.0",
    "dockerode": "^3.2.1",
    "eslint": "^8.39.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-import": "latest",
    "eslint-plugin-jasmine": "^4.1.3",
    "eslint-plugin-jsdoc": "latest",
    "eslint-plugin-prefer-arrow": "latest",
    "eslint-plugin-prettier": "^5.5.5",
    "jasmine-core": "~3.8.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.3.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.0.3",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "prettier": "^3.0.0",
    "ts-node": "~8.3.0",
    "typescript": "~5.8.3"
  },
  "optionalDependencies": {
    "@nx/nx-linux-x64-musl": "^20.3.3"
  },
  "overrides": {
    "nth-check": "^2.0.1",
    "tar": "^7.5.11",
    "tar-fs": "^3.0.4",
    "node-forge": "^1.3.2"
  }
}
